export enum CanViewEnum {
  CAN = "CAN",
  CAN_COUNTRY = "CAN_COUNTRY"
}

export const canViewItems = [
  { text: "Can", value: CanViewEnum.CAN },
  { text: "Can by country and year", value: CanViewEnum.CAN_COUNTRY }
]
